<template>
    <div class="doctor-detail">
        <header-child></header-child>
        <div class="doctor-box">
            <div class="main-content">
                <div class="doctor-img">
                    <div class="img-box clearfix mb16">
                        <div class="img-left fl">
                            <img :src="data.img" alt="" class="img-responsive">
                        </div>
                        <div class="img-out fr">
                            <p class="color-blank fs16 fwb name mb8 txt_limit">{{data.name}}</p>
                            <p class="color-blank fs14 post mb8 txt_limit">{{data.position}}</p>
                            <p class="color-gray fs14 depart txt_limit">{{data.department}}</p>
                        </div>
                    </div>
                    <div class="img-reverve color-blue fs12 tc" @click="goReverve(data.doctor_id)" v-if="data.allow_appointment==1">预约</div>
                </div>    
                <div class="quill-editor">
                    <div class="ql-container ql-snow">
                        <div class="ql-editor editor pre-wrap" v-html="data.content"></div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import HeaderChild from '@/components/HeaderChild'
export default {
    data() {
        return {
            data:{}
        };
    },
    computed: {

    },
    created() {
        this.getDetail();
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        goReverve:function(){
            this.$router.push('/doctorGroupReserve'+'/'+this.data.hospital_id+'/'+this.data.sub_hospital_id+'/'+this.data.branch_id+'/'+this.data.name+'/'+this.data.hospital_name+'.html');
        },
        getDetail:function(){
            this.$axios.post(this.api.doctorGroup.detail,{id:this.$route.params.id},res =>{
                this.data=res.data;
            },err =>{
                this.data={};
            });
        }
    },
    components: {
        HeaderChild
    },
};
</script>

<style scoped lang="less">
.doctor-box{
    padding:16px;
    .main-content{
        padding:16px;
        background:#fff;
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        .doctor-img{
            position: relative;
            .img-box{
                padding-right:56px;
                .img-left{
                    width:80px;
                    height:80px;
                }
                .img-out{
                    width:167px;
                }
                .name{
                    height:22px;
                    line-height:22px;
                }
                .post{
                    height:20px;
                    line-height:20px;
                }
                .depart{
                    height:20px;
                    line-height:20px;
                }
            }
            
            .img-reverve{
                position:absolute;
                top:50%;
                right:0;
                width:56px;
                height:25px;
                line-height:25px;
                border-radius:13px;
                border:1px solid rgba(13,52,130,1);
                margin-top:-12.5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/doctors/detail.vue